import ApiBase from 'Services/Api/ApiBase';

class SupportTickets extends ApiBase {
    route = '/admin/networking/support-tickets';
}

export default new SupportTickets();
